import { Axios } from "index";

export const flitchItemSrnoDropdownApi = "/flitch-inventory/item-srno-dropdown";
export const flitchInwardSrnoDropdownApi = "/flitch-inventory/inward-srno-dropdown";

//Approval
export const fetchFlitchApprovalApi = `/approval/flitch-approval-invoice-listing`;
export const fetchFlitchItemsApprovalApi = function (id, invoice_id) {
  return `/approval/flitch-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const flitchApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/flitch-approve_invoice_details/${id}/${invoice_id}`;
};
export const flitchRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/flitch-reject_invoice_details/${id}/${invoice_id}`;
};

export const dropdownLogByOrderItemIdApi = async (_id) => {
  const res = await Axios.get(`/flitch-inventory/log-no-dropdown/${_id}`);
  return res;
};

export const listFlitchDetailsByLogItemIdApi = async (_id) => {
  const res = await Axios.get(`/flitch-inventory/list-flitch-details/${_id}`);
  return res;
};

export const issueRawFlitchOrderdApi = async (data) => {
  const res = await Axios.post(`/order/issue-raw-flitch-order/issue-order`, data);
  return res;
};

export const revertFlitchOrderApi = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};